<template>
  <div>
    <CRow>
      <CCol sm="12" md="12">
        <CCard accent-color="primary">
          <CCardHeader
            class="font-weight-bold d-flex justify-content-between catalogo-text"
          >
            Catálogo de productos
            <router-link :to="{ name: 'NuevoProducto' }">
              <CButton color="primary" class="mr-1">
                <CIcon class="mr-1" name="cil-pencil" />Registrar Producto
              </CButton>
            </router-link>
          </CCardHeader>
          <CCardBody>
            <!-- <div class="w-100 d-flex justify-content-center align-items-center" v-if="isLoading">
              <div class="sk-flow">
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
                <div class="sk-flow-dot bg-primary"></div>
              </div>
            </div> -->
            <CDataTable
              hover
              bordered
              small
              fixed
              :loading="isLoading"
              :items="filteredItems"
              :fields="fields"
              :items-per-page="Number(50)"
              :noItemsView="noItems"
              pagination
            >
              <template #over-table>
                <CInput
                  v-model="filter"
                  placeholder="Búsqueda por productos..."
                />
              </template>
              <template #nombre="{item, index}">
                <td v-if="filter" class="py-2">{{ item.payload.nombre }}</td>
                <td
                  v-else
                  class="py-2"
                  @click="toggleUbicaciones(index)"
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                >
                  <span>
                    <CIcon
                      v-if="
                        items.filter(
                          hijo => hijo.payload.pertenece_id == item.id
                        ).length > 0
                      "
                      name="cil-chevron-circle-down-alt"
                    />
                  </span>
                  {{ item.payload.nombre }}
                </td>
              </template>
              <template #unidad="{item, index}">
                <td v-if="filter" class="py-2">{{ item.payload.unidad }}</td>
                <td
                  v-else
                  class="py-2"
                  @click="toggleUbicaciones(index)"
                  :class="
                    `${
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? `cursor-p`
                        : ``
                    }`
                  "
                >
                  {{ item.payload.unidad }}
                </td>
              </template>

              <template #edit="{item}">
                <td class="py-2">
                  <router-link
                    :to="{ name: 'EditarProducto', params: { id: item.id } }"
                  >
                    <CButton color="success" square size="sm">Editar</CButton>
                  </router-link>
                </td>
              </template>
              <template #space="{item,index}">
                <td class="py-2">
                  <CButton
                    :disabled="
                      items.filter(hijo => hijo.payload.pertenece_id == item.id)
                        .length > 0
                        ? true
                        : false
                    "
                    color="danger"
                    @click="toggleCancel(index, item)"
                    square
                    size="sm"
                    >Borrar</CButton
                  >
                </td>
              </template>
              <template v-if="!filter" #details="{item, index}">
                <CCollapse :show="details.includes(index)">
                  <table-collapse-products
                    @click-cancel="toggleCancel"
                    :productoPadre="item.id"
                    :productos="
                      items.filter(hijo => hijo.payload.raiz_id == item.id)
                    "
                  ></table-collapse-products>
                </CCollapse>
              </template>
            </CDataTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>

    <CModal
      :show.sync="cancelModal"
      :no-close-on-backdrop="true"
      :centered="true"
      title="Borrar Actividad"
      color="danger"
    >
      <h5 class="text-center">
        ¿Deseas borrar el producto {{ this.itemModal.name }}?
      </h5>
      <template #header>
        <h5 class="modal-title">Borrar Actividad</h5>
        <CButtonClose @click="cancelModal = false" class="text-white" />
      </template>
      <template #footer>
        <CButton @click="cancelModal = false" color="danger">Cancelar</CButton>
        <CButton
          @click="deleteProducto(itemModal.index, itemModal.id)"
          color="success"
          >Aceptar</CButton
        >
      </template>
    </CModal>
  </div>
</template>

<script>
import TableCollapseProducts from "../../customComponents/TableCollapseProducts";

const fields = [
  { key: "nombre", label: "Nombre", _style: "width:50%" },
  { key: "unidad", label: "Unidad", _style: "width:50%" },
  {
    key: "edit",
    label: "",
    _style: "width:10%",
    sorter: false,
    filter: false
  },
  {
    key: "space",
    label: "",
    _style: "width: 10%",
    sorter: false,
    filter: false
  }
];

export default {
  name: "Productos",
  components: {
    TableCollapseProducts
  },

  data() {
    return {
      items: [],
      itemsHijos: [],
      fields,
      filter: "",
      cancelModal: false,
      details: [],
      itemModal: { id: "", name: "", index: "" },
      noItems: { noResults: "Sin Resultados", noItems: "Sin Resultados" },
      isLoading: false
    };
  },

  created() {
    this.isLoading = true;
    this.$store
      .dispatch("customHTTP", { schema: "productos" })
      .then(res => {
        this.items = res.data;
        // res.data.forEach(ubicacion => {
        //   if (ubicacion.payload.pertenece_id == 0) {
        //     this.items.push(ubicacion);
        //   } else {
        //     this.itemsHijos.push(ubicacion);
        //   }
        // });
      })
      .finally(() => (this.isLoading = false));
  },

  computed: {
    filteredItems() {
      if (this.filter) {
        return (
          this.items
            // .filter(i => i.payload.pertenece_id == 0)
            .filter(i => i.payload?.nombre?.toLowerCase().includes(this.filter))
        );
      } else {
        return this.items.filter(i => i.payload.pertenece_id == 0);
        // .filter(i =>
        //   i.payload.nombre.toLowerCase().includes(this.filter.toLowerCase())
        // );
      }
    }
  },

  methods: {
    toggleEdit(index, item) {
      this.modal = true;
      const itemIndex = {
        id: index,
        name: item.nombre
      };
      this.itemModal = itemIndex;
    },
    toggleCancel(index, item) {
      this.cancelModal = true;
      // console.log(this.items.indexOf(item));

      const itemIndex = {
        id: item.id,
        name: item.payload.nombre,
        index: this.items.indexOf(item)
      };
      this.itemModal = itemIndex;
    },
    toggleUbicaciones(index) {
      const position = this.details.indexOf(index);
      position !== -1
        ? this.details.splice(position, 1)
        : this.details.push(index);
    },
    deleteProducto(index, id) {
      this.isLoading = true;
      this.$store
        .dispatch("customEliminarHTTP", {
          schema: "productos",
          id: id
        })
        .then(res => {
          console.log(res.data);
        })
        .catch(rej => {
          console.log(rej);
        })

        .finally(() => {
          this.isLoading = false;
          if (index !== -1) {
            this.items.splice(index, 1);
          }
          this.cancelModal = false;
        });
    }
  }
};
</script>

<style src="spinkit/spinkit.min.css"></style>

<style scoped>
.catalogo-text {
  font-size: 1.2rem !important;
}
.line {
  color: #321fdb; /* old IE */
  background-color: #321fdb; /* Modern Browsers */
}
.custom-width40 {
  width: 50%;
}
.custom-width5 {
  width: 10%;
}
.cursor-p {
  cursor: pointer;
}
</style>
